/**
 * Supported locales configuration
 * Shared between web and mobile apps
 */
export const locales = ['en-US', 'es-ES', 'en-GB', 'pt-PT'] as const;

export type Locale = (typeof locales)[number];

export const defaultLocale: Locale = 'en-GB';
/**
 * Check if a string is a valid locale
 */
export function isValidLocale(locale: string): locale is Locale {
  return locales.includes(locale as Locale);
}

/**
 * Get the language code from a locale (e.g., 'en-US' -> 'en')
 */
export function getLanguageFromLocale(locale: string): string {
  return locale.split('-')[0];
}

/**
 * Locale display names for UI
 */
export const localeDisplayNames: Record<Locale, string> = {
  'en-US': 'English (US)',
  'pt-PT': 'Português (Portugal)',
  'es-ES': 'Español (España)',
  'en-GB': 'English (UK)',
};
